module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "290px"
    }
  }, [_c('b-container', {
    staticClass: "detail-list"
  }, [_c('b-row', {
    staticClass: "detail-list__title"
  }, [_c('b-col', [_vm._v("サジェスション")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "detail-list__btn",
    class: _vm.markDown ? 'detail-list__btn--diactive' : 'detail-list__btn--active',
    attrs: {
      "disabled": _vm.markDown
    },
    on: {
      "click": _vm.exeSuggestDiscount
    }
  }, [_c('span', [_vm._v("マークダウン")])])]), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "detail-list__btn",
    class: _vm.addOrder ? 'detail-list__btn--diactive' : 'detail-list__btn--active',
    attrs: {
      "disabled": _vm.addOrder
    },
    on: {
      "click": _vm.exeSuggestOrder
    }
  }, [_c('span', [_vm._v("追加発注")])])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "detail-list__title"
  }, [_c('b-col', [_vm._v("予測結果")])], 1), _vm._v(" "), _c('table', {
    staticClass: "detail-result-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "detail-result-table__header"
  }, [_vm._v("予測")]), _vm._v(" "), _c('th', {
    staticClass: "detail-result-table__header"
  }, [_vm._v("カスタム予測")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-result-table__item-header"
  }, [_vm._v("販売数")]), _vm._v(" "), _c('td', {
    staticClass: "detail-result-table__item-data"
  }, [_vm._v(_vm._s(_vm.salesSum))]), _vm._v(" "), _c('td', {
    staticClass: "detail-result-table__item-data",
    class: _vm.csspredictState
  }, [_vm._v(_vm._s(_vm.customSalesSum) + "\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-result-table__item-header"
  }, [_vm._v("売上金額")]), _vm._v(" "), _c('td', {
    staticClass: "detail-result-table__item-data"
  }, [_vm._v(_vm._s(_vm.salesAmount))]), _vm._v(" "), _c('td', {
    staticClass: "detail-result-table__item-data",
    class: _vm.csspredictState
  }, [_vm._v(_vm._s(_vm.customSalesAmount) + "\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-result-table__item-header"
  }, [_vm._v("粗利益")]), _vm._v(" "), _c('td', {
    staticClass: "detail-result-table__item-data"
  }, [_vm._v(_vm._s(_vm.profit))]), _vm._v(" "), _c('td', {
    staticClass: "detail-result-table__item-data",
    class: _vm.csspredictState
  }, [_vm._v(_vm._s(_vm.customProfit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-result-table__item-header"
  }, [_vm._v("残在庫数")]), _vm._v(" "), _c('td', {
    staticClass: "detail-result-table__item-data"
  }, [_vm._v(_vm._s(_vm.stock))]), _vm._v(" "), _c('td', {
    staticClass: "detail-result-table__item-data",
    class: _vm.csspredictState
  }, [_vm._v(_vm._s(_vm.customStock))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-result-table__item-header"
  }, [_vm._v("予測消化率")]), _vm._v(" "), _c('td', {
    staticClass: "detail-result-table__item-data"
  }, [_vm._v(_vm._s(_vm.consumption))]), _vm._v(" "), _c('td', {
    staticClass: "detail-result-table__item-data",
    class: _vm.csspredictState
  }, [_vm._v(_vm._s(_vm.customConsumption) + "\n        ")])])])]), _vm._v(" "), _c('b-row', {
    staticClass: "detail-list__title"
  }, [_c('b-col', [_vm._v("詳細情報")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "detail-list__label",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("アイテムカテゴリ")]), _vm._v(" "), _c('b-col', {
    staticClass: "detail-list__label-name"
  }, [_vm._v(_vm._s(_vm.categoryName))])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "detail-list__label",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('b-col', {
    staticClass: "detail-list__label-name"
  }, [_vm._v(_vm._s(_vm.itemName))])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "detail-list__img"
  }, [_c('b-col', {
    staticClass: "detail-list__label",
    staticStyle: {
      "margin-bottom": "auto",
      "margin-top": "auto"
    },
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("商品画像\n      ")]), _vm._v(" "), _c('b-col', [_c('img', {
    class: {
      'nodisplay': !_vm.image
    },
    attrs: {
      "src": _vm.image,
      "width": "auto",
      "height": "100"
    }
  })])], 1), _vm._v(" "), _c('div', {
    class: {
      nodisplay: (_vm.itemId === '') || (_vm.itemId !== '' && _vm.skuId !== '')
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "detail-list__label",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("販売期間")]), _vm._v(" "), _c('b-col', {
    staticClass: "detail-list__label-value"
  }, [_vm._v("\n          " + _vm._s(_vm.lifeCycle) + "\n          "), _c('span', {
    staticClass: "detail-list__label-unit"
  }, [_vm._v("週")])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "detail-list__label",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("追加発注"), _c('br'), _vm._v("リードタイム")]), _vm._v(" "), _c('b-col', {
    staticClass: "detail-list__label-multi-value"
  }, [_vm._v("\n          " + _vm._s(_vm.leadTime) + "\n          "), _c('span', {
    staticClass: "detail-list__label-unit"
  }, [_vm._v("週")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "detail-list__label-end"
  }, [_c('b-col', {
    staticClass: "detail-list__label",
    attrs: {
      "cols": "4"
    }
  }, [_vm._v("追加発注"), _c('br'), _vm._v("最低ロット")]), _vm._v(" "), _c('b-col', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectOrderLot),
      expression: "selectOrderLot"
    }],
    staticClass: "detail-list__select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectOrderLot = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateItemset]
    }
  }, _vm._l((_vm.lots), function(lot) {
    return _c('option', {
      domProps: {
        "value": lot.value
      }
    }, [_vm._v("\n              " + _vm._s(lot.text) + "\n            ")])
  }), 0)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17cac2be","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./src/components/aftersale/predict/detail/detail.html
// module id = 693
// module chunks = 0